<div class="p-3 bg-green color-white">
	<p class="page-title small uc text-center mb-0"><?=( visit.collection ? 'Modifier la visite' : 'Nouvelle visite' )?></p>
</div>
<div class="p-3 text-center bb">
	<p class="mb-0">
		<a href="#<?=pond.toUrl('pond/view')?>" class="badge badge-dark badge-lg fw-400 mr-1">Mare #<?=pond.get('id')?></a>
		<span class="badge badge-<?=pond.getStatus().color?> badge-lg fw-400"><?=pond.getStatus().name?></span>
	</p>
</div>

<form id="visit_form">
	<? var s = 0; _.each( form, function( section ) { s++ ?>

	<!-- Conditions -->
		<div class="list-nav-accordion list-group">
			<div class="list-group-item collapsed toggle-accordion-content" data-toggle="collapse" data-target="#form-<?=section.id?>">
				<span class="badge badge-success"><?=s?>/<?=_.size( form )?></span>
				<span class="label"><?=section.name?></span>
			</div>
		</div>
		<div id="form-<?=section.id?>" class="form-section bb collapse">
			<? _.each( section.list, function( field ) { ?>
				<div id="field-<?=field.id?>" class="p-3">
					<div class="form-group m-0 <?=( field.required ? 'is-required' : 'not-required' )?>">

						<? if( field.type == 'radio' || field.type == 'checkbox' ) { ?>
							<?-visit.getFieldLabel( field.id, field.name, { class: 'control-label fw-600' } )?>
							<?-visit.getFieldInput( field.id, { type: field.type, choices: _.object( field.values, field.values ) } )?>
						<? } else if( field.type == 'select' ) { ?>
							<?-visit.getFieldLabel( field.id, field.name, { class: 'control-label fw-600' } )?>
							<?-visit.getFieldInput( field.id, { type: 'select', choices: _.extend({ "":"" }, _.object( field.values, field.values ) ) } )?>
						<? } else if( field.type == 'multiselect' ) { ?>
							<?-visit.getFieldLabel( field.id, field.name, { class: 'control-label fw-600' } )?>
							<?-visit.getFieldInput( field.id, { type: 'select', choices: _.object( field.values, field.values ), multiple: true, size: 1, style: "height: calc(1.5em + .75rem + 2px)" } )?>
						<? } else if( field.type == 'textarea' ) { ?>
							<?-visit.getFieldLabel( field.id, field.name, { class: 'control-label fw-600' } )?>
							<?-visit.getFieldInput( field.id, { type: field.type, rows: 3 } )?>
						<? } else if( field.type == 'boolean' ) { ?>
							<div class="custom-control custom-checkbox">
								<?-visit.getFieldInput( field.id, { type: 'boolean', class: 'custom-control-input' } )?>
								<?-visit.getFieldLabel( field.id, field.name, { class: 'custom-control-label' } )?>
							</div>
						<? } else { ?>
							<?-visit.getFieldLabel( field.id, field.name, { class: 'control-label fw-600' } )?>
							<?-visit.getFieldInput( field.id, { type: field.type } )?>
						<? } ?>

						<?-visit.getFieldError( field.id )?>

						<? if( !_.isEmpty( field.help ) ) { ?>
							<div class="small text-secondary mt-2"><?-field.help?></div>
						<? } ?>
					</div>
				</div>
			<? }) ?>
		</div>
	<? }) ?>

	<div class="p-3">
		<? if( visit.isNew() ) { ?>
			<p class="text-center mb-2"><button type="submit" class="btn btn-green btn-block">Enregistrer et prévisualiser</button></p>
		<? } else { ?>
			<p class="text-center mb-2"><button type="submit" class="btn btn-green btn-block">Mettre à jour la visite</button></p>
		<? } ?>
		<p class="mb-0 text-center text-secondary small">Votre visite sera enregistrée en brouillon en attente d'envoi sur le serveur</p>
	</div>

</form>
